export enum EnumAttachmentStatus {
  Processing = 'processing',
  Ready = 'ready',
  Failed = 'failed',
  Deleted = 'deleted',
  Unknown = 'unknown'
}
